<template lang="pug">
  v-row.ma-0
    v-col.pa-0.pr-2.pl-2(cols="12")
      v-card.elevation-4.title(flat :color="getCardStyle")
        v-card-title.text-h5.font-weight-bold.pa-0
          v-row.ma-0
            v-col(cols="10") {{ $t('dashboardPage.totalReservationsTitle') }}
            v-col.text-end.pa-0.pt-3.pr-1(cols="2" )
              v-btn(:loading="loading" icon v-if="loading")
                v-icon(medium color="black") fas fa-spinner
        v-row.ma-0.toolbar-style
          v-col.text-start(cols="2" md="3")
            v-btn.text-end.pl-md-4(@click="onPrevDayClick" icon)
              v-icon.text-start fas fa-chevron-double-left
          v-col.text-h5.font-weight-bold.text-center(cols="8" md="6")
            span.pt-2 {{getTitle}} {{getDayName}} {{getFormattedDate}}
          v-col.text-end(cols="2" md="3")
            v-btn.text-end.pr-md-4(@click="onNextDayClick" icon)
              v-icon.text-end fas fa-chevron-double-right
        v-tabs.tabs-style(v-model="tab" background-color="transparent" color="primary" grow)
          v-tab {{ $t('dashboardPage.tabOverview') }}
          v-tab {{ $t('dashboardPage.tabByGroups') }}
        v-tabs-items.tabs-content(v-model="tab" v-if="isDailyMenu")
          v-tab-item
            v-card-text.pb-4.flex-shrink-0.flex-grow-1.pt-0
              DashboardReservationSummaryItem(v-for="[key, value] in data" :key="key" :groupName="key" :value="value" :date="actuallyDate")
          v-tab-item
            v-card-text.pb-4.pt-3
              DashboardBoarderGroupTagSummary(:summaryData="summaryData")
        v-card-text.pb-4.flex-shrink-0.flex-grow-1.pt-6.text-center(v-else)
          span.text-center.text-h5.font-weight-bold {{ $t('dashboardPage.noFoodMenu') }}



</template>

<script lang="ts">
import Vue from 'vue'
import {Component, Prop, Watch} from 'vue-property-decorator'
import moment from "moment/moment";
import i18n from "@/i18n";
import DashboardReservationSummaryItem from "@/components/DashboardReservationSummaryItem.vue";
import DashboardBoarderGroupTagSummary from "@/components/DashboardBoarderGroupTagSummary.vue";
import MenuGroupSummary from "@/model/MenuGroupSummary";

const TAB_STORAGE_KEY = 'dashboard.reservationSummary.tab'

@Component({
    components: {DashboardReservationSummaryItem, DashboardBoarderGroupTagSummary}
})
export default class DashboardReservationSummary extends Vue {


    @Prop({ type: Array, required: true }) readonly summaryData!: MenuGroupSummary[]
    @Prop({type: String, required: false}) date!: string
    @Prop({type: Boolean, required: false}) loading!: false
    @Prop({ type: Map<string, {title: string, value: number}[]>, required: true }) readonly data!: any

    private actuallyDate: string = ''
    /** 0 = Prehľad (per slot), 1 = Po skupinách (per boarder-group tag); remembered per browser */
    private tab: number = 0

    get isDailyMenu ():boolean {
      if(this.summaryData && this.summaryData[0] && this.summaryData[0].foodItemSummary.length > 0) {
          return true
      } else {
          return false
      }
    }

    get getCardStyle (): string {
        if(this.actuallyDate && this.actuallyDate === moment().format('YYYY-MM-DD')) {
            return '#E0F2F1'
        } else {
            return '#f3efef'
        }
    }

    get getDayName (): string {
        if(this.summaryData) {
            this.summaryData.forEach((item: MenuGroupSummary) => {
                this.actuallyDate = item.date
            })
        }
        if(this.actuallyDate) {
            return moment(this.actuallyDate, 'YYYY-MM-DD').locale(i18n.locale).format('dddd')
        } else {
            return ''
        }
    }

    get getTitle (): string {
        if(this.actuallyDate) {
            if(this.actuallyDate === moment().format('YYYY-MM-DD')) {
                return this.$t('dashboardPage.today').toString()
            } else if (this.actuallyDate === moment().add(1,'day').format('YYYY-MM-DD')) {
                return this.$t('dashboardPage.tomorrow').toString()
            } else if (this.actuallyDate === moment().subtract(1,'day').format('YYYY-MM-DD')) {
                return this.$t('dashboardPage.yesterday').toString()
            } else {
                return ''
            }
        } else {
            return ''
        }
    }

    get getFormattedDate (): string {
        if(this.summaryData) {
            this.summaryData.forEach((item: MenuGroupSummary) => {
                this.actuallyDate = item.date
            })
        }
        if(this.actuallyDate) {
            return moment(this.actuallyDate, 'YYYY-MM-DD').format('D.M.YYYY')
        } else {
            return ''
        }
    }

    onNextDayClick() : void {
        const payload: string = moment(this.actuallyDate, 'YYYY-MM-DD').add(1,'day').format('YYYY-MM-DD')
        this.$emit('fetchData', payload)
    }

    onPrevDayClick() : void {
        const payload: string = moment(this.actuallyDate, 'YYYY-MM-DD').subtract(1,'day').format('YYYY-MM-DD')
        this.$emit('fetchData', payload)
    }

    @Watch('tab')
    onTabChange (value: number): void {
      try {
        localStorage.setItem(TAB_STORAGE_KEY, String(value))
      } catch (e) {
        // storage unavailable (private mode etc.) — the tab just won't be remembered
      }
    }

    mounted () {
        this.actuallyDate = this.date
        try {
          const stored = localStorage.getItem(TAB_STORAGE_KEY)
          if (stored === '1') {
            this.tab = 1
          }
        } catch (e) {
          // ignore
        }
    }
}
</script>

<style lang="stylus" scoped>
.toolbar-style
  background-color white

.tabs-style
  >>> .v-tabs-bar
    background-color transparent !important

.tabs-content
  background-color transparent !important
</style>
